import React, { Component } from 'react';

import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import Avatar from '@material-ui/core/Avatar';
import Icon from '@material-ui/core/Icon';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';

import FileUploader from '../../components/FileUploader';

import Loader from '../../../../components/Loader';
import { getMediaStorageRef, getFileIndexRef } from '../../../../config/firebase';
import { getAllItems } from '../../../../utils';

class Media extends Component {
  constructor(props) {
    super(props);

    this.state = {
      files: null,
      fileToDelete: {},
      isDialogOpen: false,
    }

    this.dbFilesRef      = getFileIndexRef();
    this.storageMediaRef = getMediaStorageRef();

    this.conformFileDeletion = this.conformFileDeletion.bind(this)
    this.handleDialogClose   = this.handleDialogClose.bind(this)
    this.handleFileDeletion  = this.handleFileDeletion.bind(this)
  }

  componentDidMount() {
    getAllItems(this.dbFilesRef, (files) => {
      if (files.length > 0) {
        this.setState({files});
      } else {
        this.setState({files: 'no-files'});
      }
    }, false);
  }

  componentWillUnmount() {
    this.dbFilesRef.off();
  }

  conformFileDeletion(file) {
    this.setState({
      fileToDelete: file,
      isDialogOpen: true,
    });
  }

  handleFileDeletion() {
    this.storageMediaRef.child(this.state.fileToDelete.name).delete().then(() => {
      this.dbFilesRef.child(this.state.fileToDelete.id).remove().then(() => {
        this.setState({
          fileToDelete: {},
          isDialogOpen: false
        });
      });
    });
  }

  handleDialogClose() {
    this.setState({
      isDialogOpen: false,
    });
  }

  fileIcon(name) {
    const extension = name.split('.').pop();
    let icon;
    switch (extension) {
      case 'mp3':
        icon = 'music_note';
        break;
      case 'mp4':
        icon = 'local_movies';
        break;
      default:
        icon = 'insert_drive_file'
    }
    return icon;
  }

  render() {
    let uploadedFiles;

    if ( this.state.files === 'no-files' ) {
      uploadedFiles = <p>You haven't uploaded any file yet!</p>
    } else if (this.state.files === null) {
      uploadedFiles = <Loader />;
    } else {
      const listItems = this.state.files.map((file, index) => (
        <ListItem key={index} divider>
          <Avatar>
            <Icon>{this.fileIcon(file.name)}</Icon>
          </Avatar>
          <ListItemText primary={file.title} />
          <ListItemSecondaryAction>
            <IconButton color="primary" href={file.url} target="_blank">
              <Icon>file_download</Icon>
            </IconButton>
            <IconButton aria-label="delete" color="secondary" onClick={() => this.conformFileDeletion(file)}>
              <Icon>delete</Icon>
            </IconButton>
          </ListItemSecondaryAction>
        </ListItem>
      ));

      uploadedFiles = <List>{listItems}</List>
    }

    return (
      <div className="wrapper">
        <Typography variant="headline" component="h5">Upload</Typography>
        <FileUploader />

        <Typography variant="headline" component="h5">Uploaded files</Typography>
        {uploadedFiles}
        <Dialog
          open={this.state.isDialogOpen}
          onClose={this.handleDialogClose}
          aria-labelledby="delete-file-dialog-title"
          aria-describedby="delete-file-dialog-description"
        >
          <DialogTitle id="delete-file-dialog-title">Delete file?</DialogTitle>
          <DialogContent>
            <DialogContentText id="delete-file-dialog-description">
              Are you sure you want to delete <strong>{this.state.fileToDelete.title}</strong>?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleFileDeletion} color="secondary">Delete</Button>
            <Button onClick={this.handleDialogClose} autoFocus>Cancel</Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default Media;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Media/index.js